export default {
  model: {
    'role': '角色',
    'activeStorage/attachment': 'Attachment',
    'localScenery': '地方风光',
    'station': '站点',
    'application': '应用管理',
    'adminUsersRole': '管理员',
    'adminUser': '管理员',
    'profile': 'Profile',
    'user': '用户',
    'activeStorage/blob': '资源',
    'actsAsTaggableOn/tag': '标签',
    'page': '静态页面',
    'customPage': '自定义页面',
    'operationRecord': '操作日志',
    'frequentlyAskedQuestion': '常见问题',
    'passenger': '常用乘客',
    'booking': '车票订单',
    'payment': 'Payment',
    'route': '路线',
    'requestLog': '请求日志',
    'banner': '轮播图',
    'hotWord': '搜索热词',
    'presetPage': '静态页面',
    'roleCore/role': '角色',
    'staticPage': '静态页面',
  },
  'role': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    kinds: {
      super: 'Super',
      application: '应用管理',
      custom: 'Custom',
    },
    customPermissions: '自定义权限',
  },
  'activeStorage/attachment': {
    id: 'ID',
    createdAt: '创建时间',
    signedId: 'Signed',
    contentType: 'Content type',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
  },
  'localScenery': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    appid: '小程序appid',
    name: '名称',
    path: '小程序路径',
    envVersion: '小程序版本',
    envVersions: {
      release: '正式版',
      develop: '开发版',
      trial: '体验版',
    },
    jumpPageType: '跳转页面类型',
    jumpPageTypes: {
      local: '本地页面',
      mini_program: '外部小程序',
    },
    position: '权重',
    cover: '封面',
    content: '内容',
    stationIds: 'Station ids',
    stations: '站点',
  },
  'station': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    eurostarUic: 'UIC',
    position: '优先级',
    eurostarActive: '有效',
    popular: '热门',
    name: '名称',
    shortCode: 'Code',
    prompt: '提示',
    stdTicketTips: '标准舱车票提示语',
    spTicketTips: '标准贵宾舱车票提示语',
    bpTicketTips: '商务舱车票提示语',
    nonFlexibleDesc: '非灵活票规则',
    semiFlexibleDesc: '半灵活票规则',
    fullyFlexibleDesc: '全灵活票规则',
    fakeLeg: 'Fake leg',
    country: '国家',
    nameZhCn: '中文名',
    standardServices: '标准服务',
    standardPremierServices: '标准高级服务',
    businessPremierServices: '商务高级服务',
    novStandardServices: '11.4标准服务',
    novStandardPremierServices: '11.4标准高级服务',
    novBusinessPremierServices: '11.4商务高级服务',
    localSceneryIds: 'Local scenery ids',
    localSceneries: '地方风光',
  },
  'application': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    desc: '描述',
    shareDesc: '分享描述',
    shareTitle: '分享标题',
    wechatApplicationId: 'Wechat application',
    nonFlexibleDesc: '非灵活票规则',
    semiFlexibleDesc: '半灵活票规则',
    fullyFlexibleDesc: '全灵活票规则',
    novNonFlexibleDesc: '11.4非灵活票规则',
    novSemiFlexibleDesc: '11.4半灵活票规则',
    novFullyFlexibleDesc: '11.4全灵活票规则',
    specialFlexibleDesc: '特殊售后规则',
    stationPrompt: '站点提示',
    stdTicketTips: '标准舱车票提示语',
    spTicketTips: '标准贵宾舱车票提示语',
    bpTicketTips: '商务舱车票提示语',
    homepageLocalSceneryIds: '首页地方风光',
    afterSalesReasonCodes: '规则原因代码',
    newAfterSaleCodeNotifyEmails: '新售后代码通知邮箱',
    allAfterSaleCodes: '所有已知售后代码',
    homePopupStartAt: '首页弹窗开始时间',
    homePopupEndAt: '首页弹窗结束时间',
    standardCodes: '标准仓',
    vipCodes: '高等舱',
    businessCodes: '贵宾舱',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: '分享图片',
    logo: 'Logo',
    bannerImage: '首页横幅',
    mineBannerImage: '我的页面横幅',
    standardServices: '标准服务',
    standardPremierServices: '标准高级服务',
    businessPremierServices: '商务高级服务',
    novStandardServices: '11.4标准服务',
    novStandardPremierServices: '11.4标准高级服务',
    novBusinessPremierServices: '11.4商务高级服务',
    homepageLocalSceneries: '首页地方风光',
    homePopupImage: '首页弹窗图片',
    creator: 'Creator',
    posterImage: '海报图片',
  },
  'adminUsersRole': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    roleId: '角色',
    adminUserId: 'Admin user',
    applicationId: '应用ID',
    isBlock: '已冻结',
    role: '角色',
    application: '应用管理',
    adminUser: '管理员',
    adminUserAttributes: 'Admin user attributes',
  },
  'adminUser': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    email: '邮箱',
    name: '姓名',
    isBlock: '已冻结',
    adminUsersRolesAttributes: 'Admin users roles attributes',
  },
  'profile': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    email: '邮箱',
    phone: '手机号码',
    gender: '性别',
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
  },
  'user': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    screenName: '名称',
    isBlock: '已冻结',
    profile: 'Profile',
    email: '邮箱',
    phone: '手机号码',
    phoneCountryCode: '国家区号',
    avatar: '头像',
  },
  'activeStorage/blob': {
    id: 'ID',
    createdAt: '创建时间',
    signedId: 'Signed',
    contentType: '类型',
    filename: '文件名',
    byteSize: 'Byte size',
    url: '内容',
    tagList: 'Tag list',
  },
  'actsAsTaggableOn/tag': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'page': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    slug: 'Slug',
    title: '标题',
    type: '类型',
    applicationId: '应用ID',
    viewsCount: '浏览数',
    publishedAt: '发布时间',
    wxacode: '小程序码',
    content: '内容',
  },
  'customPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    default: '预置页面',
    miniProgramPath: '小程序路径',
    publishedAt: '最后发布时间',
    formalCustomPageId: 'Formal custom page',
    formalCustomPage: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: '自定义页面',
  },
  'operationRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    operatableType: '操作对象类型',
    operatableId: '操作对象ID',
    operatorType: 'Operator type',
    operatorId: 'Operator',
    ipAddress: 'IP地址',
    operator: '操作者',
    operatable: '操作对象',
    operationDescription: '操作描述',
    requestPath: '请求路径',
    requestMethod: '请求方法',
    requestParams: '请求数据',
    previousObject: 'Previous object',
    currentObject: 'Current object',
  },
  'frequentlyAskedQuestion': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    question: '问题',
    position: '优先级',
    answer: '答案',
  },
  'passenger': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    email: '邮箱',
    firstName: '名',
    lastName: '姓',
    phoneCountryCode: '国家区号',
    phone: '手机号码',
    passengerType: '类型',
    passengerTypes: {
      adult: 'Adult',
      senior: 'Senior',
      youth: 'Youth',
      child: 'Child',
    },
    userId: 'User',
    birthday: '生日',
    user: '用户',
  },
  'booking': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    reference: 'Reference',
    tickets: 'Tickets',
    transactionId: 'Transaction',
    status: '状态',
    statuses: {
      provisional: 'Provisional',
      wait_to_pay: 'Wait to pay',
      wait_to_add_payment: 'Wait to add payment',
      ready_to_be_confirmed: 'Ready to be confirmed',
      confirmed: 'Confirmed',
      in_aftersales: 'In aftersales',
      cancelled: 'Cancelled',
      rebooking: 'Rebooking',
      closed: 'Closed',
    },
    refundState: 'Refund state',
    refundStates: {
      pending: 'Pending',
      partial_refund: 'Partial refund',
      all_refund: 'All refund',
    },
    userId: 'User',
    paidAt: 'Paid at',
    lastRefundPaymentStatus: 'Last refund payment status',
    user: '用户',
    response: 'Response',
    realPayAmount: '实付金额',
    payments: 'Payments',
  },
  'payment': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    amountInCent: 'Amount in cent',
    type: 'Type',
    status: '状态',
    statuses: {
      pending: 'Pending',
      not_processed: 'Not processed',
      expired: 'Expired',
      call_failed: 'Call failed',
      authorized: 'Authorized',
      not_authorized: 'Not authorized',
    },
    completedAt: 'Completed at',
    customerToken: 'Customer token',
    merchantToken: 'Merchant token',
    transactions: 'Transactions',
    parentId: 'Parent',
    transactionId: 'Transaction',
    refundItemRef: 'Refund item ref',
    totalRefundAmountInCent: 'Total refund amount in cent',
  },
  'route': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    destinationId: '终点站',
    originId: '始发站',
    active: '有效',
    roundTrip: '往返',
    destination: '终点站',
    origin: '始发站',
  },
  'requestLog': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    targetId: '单号',
    targetType: '目标类型',
    title: '标题',
    url: '请求路径',
    params: '请求参数',
    response: '响应数据',
  },
  'banner': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    target: '目标',
    position: '优先级',
    pagePosition: '页面位置',
    pagePositions: {
      event: '事件',
    },
    kind: '类型',
    kinds: {
      web_link: '网站链接',
      image: '纯图片',
      mp_link: '小程序链接',
    },
    alt: '图片描述',
    image: '图片',
  },
  'hotWord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    position: '优先级',
    applicationId: '应用ID',
    application: '应用管理',
  },
  'presetPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    viewsCount: '浏览数',
    content: '内容',
  },
  'roleCore/role': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    customPermissions: 'Custom permissions',
  },
  'staticPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    status: '状态',
    viewsCount: '浏览数',
    wxacode: '小程序码',
    content: '内容',
  },
}
